import { NgModule } from '@angular/core';
import {
  ButtonV2Module,
  CheckboxV2Module,
  IconV2Module,
  InputV2Module,
  ModalModule,
  PipesModule,
  RadioV2Module,
  SelectV2Module,
  SpinnerModule,
} from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CreateEditUserModalComponent } from './create-edit-user-modal/create-edit-user-modal.component';
import { DeleteUserModelComponent } from './delete-user-modal/delete-user-modal.component';

@NgModule({
  imports: [
    ModalModule.forRoot(),
    TranslatePipe,
    TranslateDirective,
    ButtonV2Module,
    InputV2Module,
    RadioV2Module,
    CheckboxV2Module,
    SpinnerModule.forRoot(),
    CommonModule,
    IconV2Module,
    ReactiveFormsModule,
    PipesModule,
    SelectV2Module,
    CreateEditUserModalComponent,
    DeleteUserModelComponent,
  ],
  exports: [],
})
export class ModalsModule {}
